import { render, staticRenderFns } from "./CustomNotification.vue?vue&type=template&id=cd94f316&scoped=true&lang=pug"
import script from "./CustomNotification.vue?vue&type=script&lang=js"
export * from "./CustomNotification.vue?vue&type=script&lang=js"
import style0 from "./CustomNotification.vue?vue&type=style&index=0&id=cd94f316&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd94f316",
  null
  
)

export default component.exports